import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

import RefluxModelListenerMixin from '../../mixins/reflux-model-listener-mixin';

const DISMISS_KEY = 'boxcast-four-k-banner-dismissed';

const isUltraHd = (broadcast) =>
  !!broadcast && typeof broadcast.transcoder_profile === 'string'
    && broadcast.transcoder_profile.indexOf('2160') === 0;

const readDismissed = () => {
  try {
    return window.localStorage.getItem(DISMISS_KEY) === 'true';
  } catch (e) {
    return false;
  }
};

const FourKBanner = createClass({
  displayName: 'FourKBanner',

  contextTypes: {
    model: PropTypes.object,
    m: PropTypes.func,
  },

  mixins: [RefluxModelListenerMixin],

  refluxModelListeners: {
    SelectedBroadcastStore: 'onStoreChanged',
  },

  getInitialState: function () {
    const { SelectedBroadcastStore } = this.context.model;
    return {
      broadcast: SelectedBroadcastStore.broadcast,
      dismissed: readDismissed(),
    };
  },

  onStoreChanged: function () {
    const { SelectedBroadcastStore } = this.context.model;
    this.setState({ broadcast: SelectedBroadcastStore.broadcast });
  },

  onDismiss: function () {
    try {
      window.localStorage.setItem(DISMISS_KEY, 'true');
    } catch (e) {
      // ignore — fall back to in-memory dismissal only
    }
    this.setState({ dismissed: true });
  },

  render: function () {
    const { m } = this.context;
    const { broadcast, dismissed } = this.state;

    if (dismissed || !isUltraHd(broadcast)) {
      return null;
    }

    return (
      <div className="boxcast-four-k-banner" role="status">
        <div className="boxcast-four-k-banner-content">
          <div className="boxcast-four-k-banner-badge">4K</div>
          <div className="boxcast-four-k-banner-text">
            <p className="boxcast-four-k-banner-heading">{m('four_k_banner_heading')}</p>
            <p className="boxcast-four-k-banner-subtext">
              {m('four_k_banner_subtext_before')}
              <i className="boxcast-icon-cog" aria-hidden="true" />
              {m('four_k_banner_subtext_after')}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="boxcast-four-k-banner-dismiss"
          onClick={this.onDismiss}
        >
          {m('four_k_banner_dismiss')}
        </button>
      </div>
    );
  },
});

export default FourKBanner;
